export default __webpack_public_path__ + "static/media/loginIcon.7b0fad38.svg";